import axios from 'axios'

import { InteractionRequiredAuthError } from '@azure/msal-browser'

import { msalInstance, tokenRequest, loginRequest } from './msalConfig'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

let cachedToken: string | null = null
let tokenExpiresAt: number | null = null

async function retrieveToken(): Promise<string | null> {
  const now = Date.now()
  if (cachedToken && tokenExpiresAt && now < tokenExpiresAt - 60 * 1000) {
    return cachedToken
  }

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) {
    return null
  }

  try {
    const { accessToken, expiresOn } = await msalInstance.acquireTokenSilent({
      ...tokenRequest,
      account: accounts[0],
    })
    cachedToken = accessToken
    tokenExpiresAt = expiresOn instanceof Date ? expiresOn.getTime() : expiresOn
    return accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.loginRedirect(loginRequest)
    }
    return null
  }
}

api.interceptors.request.use(async (config) => {
  const token = await retrieveToken()

  if (!token) {
    // Abort the request — no valid token available
    const controller = new AbortController()
    controller.abort()
    config.signal = controller.signal
    return config
  }

  config.headers['Authorization'] = `Bearer ${token}`
  config.headers['Ocp-Apim-Subscription-Key'] =
    import.meta.env.VITE_APIM_SUBSCRIPTION_KEY

  return config
})
